import { missingInput, divisionByZero } from '../warnings';
import { formulaOk, formulaUnknown, type FormulaResult } from './types';

/** SPEC-008 §24 — averageTicket = revenue / customers. */
export function averageTicket(revenue: number | null, customers: number | null): FormulaResult {
  const explanation = {
    metric: 'averageTicket',
    formula: 'revenue / customers',
    inputs: { revenue, customers },
    result: null,
    unit: 'minor_currency_per_customer',
  };
  if (revenue === null || customers === null) {
    return formulaUnknown(explanation, [missingInput('Revenue and customer count are both required to calculate average ticket.')]);
  }
  if (customers === 0) {
    return formulaUnknown(explanation, [divisionByZero('Average ticket is undefined when there are zero customers.')]);
  }
  return formulaOk(revenue / customers, { ...explanation, result: revenue / customers }, []);
}

/** SPEC-008 §32 — projected revenue = projected clients × average ticket. */
export function projectedRevenue(clients: number | null, ticket: number | null): FormulaResult {
  const explanation = {
    metric: 'projectedRevenue',
    formula: 'clients * averageTicket',
    inputs: { clients, ticket },
    result: null,
    unit: 'minor_currency',
  };
  if (clients === null || ticket === null) {
    return formulaUnknown(explanation, [missingInput('Projected clients and average ticket are both required to project revenue.')]);
  }
  return formulaOk(clients * ticket, { ...explanation, result: clients * ticket }, []);
}
